export default [{
  path: 'product/:leftid/:parent_id',
  name: 'backend_product',
  component: () => import('@/views/backend/admin/product/list/list'),
  meta: {
    tpflag: 'backend',
    title: '产品列表',
  }
}, {
  path: 'productnew/:leftid/:parent_id',
  name: 'backend_productnew',
  component: () => import('@/views/backend/admin/product/list/new'),
  meta: {
    tpflag: 'backend',
    title: '产品列表-新增/修改产品',
  }
}, {
  path: 'application/:leftid/:parent_id',
  name: 'backend_application',
  component: () => import('@/views/backend/admin/product/application/list'),
  meta: {
    tpflag: 'backend',
    title: '应用列表',
  }
}, {
  path: 'productservice/:leftid/:parent_id',
  name: 'backend_productservice',
  component: () => import('@/views/backend/admin/product/service/list'),
  meta: {
    tpflag: 'backend',
    title: '服务列表',
  }
}, {
  path: 'mallspace/:leftid/:parent_id',
  name: 'backend_mallspace',
  component: () => import('@/views/backend/admin/product/domain/list'),
  meta: {
    tpflag: 'backend',
    title: '商城站点',
  }
}, {
  path: 'mallupgrade/:leftid/:parent_id',
  name: 'backend_mallupgrade',
  component: () => import('@/views/backend/admin/product/domain/upgrade_main'),
  meta: {
    tpflag: 'backend',
    title: '商城升级',
  }
}, {
  path: 'wechatrelease/:leftid/:parent_id',
  name: 'backend_wechatrelease',
  component: () => import('@/views/backend/admin/product/wechatrelease/WechatReleaseMain'),
  meta: {
    tpflag: 'backend',
    title: '微信发版',
  }
}, {
  path: 'wechatreleaseprivacy/:leftid/:parent_id/:app_id',
  name: 'backend_wechatrelease_privacy',
  component: () => import('@/views/backend/admin/product/wechatrelease/PrivacySettingPage'),
  meta: {
    tpflag: 'backend',
    title: '隐私指引',
  }
}, {
  path: 'wechatreleasedefaultprivacy/:leftid/:parent_id',
  name: 'backend_wechatrelease_default_privacy',
  component: () => import('@/views/backend/admin/product/wechatrelease/DefaultPrivacySettingPage'),
  meta: {
    tpflag: 'backend',
    title: '默认隐私指引',
  }
}, {
  path: 'wechatreleaseaudit/:leftid/:parent_id/:app_id',
  name: 'backend_wechatrelease_audit',
  component: () => import('@/views/backend/admin/product/wechatrelease/AuditReleasePage'),
  meta: {
    tpflag: 'backend',
    title: '小程序提审',
  }
}, {
  path: 'mallsetting/:leftid/:parent_id',
  name: 'backend_mallsetting',
  component: () => import('@/views/backend/admin/product/domain/setting'),
  meta: {
    tpflag: 'backend',
    title: '商城设置',
  }
}, {
  path: 'mallresource/:leftid/:parent_id',
  name: 'backend_mallresource',
  component: () => import('@/views/backend/admin/product/domain/mall_resource'),
  meta: {
    tpflag: 'backend',
    title: '站点资源',
  }
}]



// WEBPACK FOOTER //
// ./src/router/kdsuper/_product.js